'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = breakpoints;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Returns an object of media queries with their respective styles.
 *
 * @param value - The prop, either a value, like 20, or an object for breakpoints,
 *                    such as { sm: 20, md: 50, xl: 80 }
 * @param theme - The theme object
 * @param mapFn - Function that will be called with the value (20), or multiple times with
 *                each individual value. Should return a style object or falsy for no styles.
 */
function breakpoints(value, theme, mapFn) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    var cssValues = Object.keys(value).reduce(function (acc, key) {
      return _extends({}, acc, breakpoint(key, mapFn(value[key]), theme));
    }, {});

    return _extends({}, mapFn(undefined), cssValues);
  }

  return mapFn(value);
}

function breakpoint(name, styles, theme) {
  var breakpointValue = theme.grid_breakpoints[name];
  var bp = '' + breakpointValue + (typeof breakpointValue === 'number' ? 'px' : '');

  return _defineProperty({}, '@media (min-width: ' + bp + ')', styles);
}


//////////////////
// WEBPACK FOOTER
// ./~/glamorous-grid/lib/breakpoints.js
// module id = ./node_modules/glamorous-grid/lib/breakpoints.js
// module chunks = 2345137460201621000 7489246917808536000 9249036036638527000